import { Editor } from '@tiptap/core';

export interface EditorPopoverContentProps {
  editor: Editor;
  closePopover: () => void;
}
type EditorPopoverVisible = { visible: true; position: DOMRect };
type EditorPopoverHidden = { visible: false };
export type EditorPopoverState = EditorPopoverVisible | EditorPopoverHidden;
export const isEditorPopoverStateVisible = (
  state: EditorPopoverState,
): state is EditorPopoverVisible => state.visible;
